import ListingsRoutingResolver from './ListingRoutingResolver';

class ProspectsListingResolver extends ListingsRoutingResolver {

    constructor() {
        super()
        this.key = "prospect"
    }
}

export default ProspectsListingResolver
